module.exports = __webpack_public_path__ + "static/media/Full_Dock.78ab9832.jpg";